import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { StyledBackButton } from './styled';

interface BackButtonProps {
  onClick: () => void;
}

export const BackButton = ({ onClick }: BackButtonProps) => (
  <StyledBackButton onClick={onClick}>
    <ArrowBackIosIcon
      viewBox="0 0 18 24"
      style={{ fontSize: 14, fill: '#fff' }}
    />
  </StyledBackButton>
);
